<mat-form-field
  appearance="outline"
  class="w-full dh-like-form-field"
  subscriptSizing="dynamic"
  [hideRequiredMarker]="true"
>
  <mat-label>{{ label() }}</mat-label>
  <mat-select
  [formControl]="control()"
  [multiple]="multiple()"
  [panelClass]="panelClasses()"
  [placeholder]="placeholder() || ''"
  (openedChange)="searchText.set('')"
>
    <div *ngIf="filter()" class="px-2 py-2 sticky top-0 z-10 bg-white">
      <input
        matInput
        placeholder="Escribe para buscar..."
        class="w-full p-2 border-b outline-none text-sm"
        (input)="handleSearch($event)"
        (keydown)="stopPropagation($event)"
        #searchInput
      />
    </div>

    @for (opt of (filter() ? filteredOptions() : options()); track trackKey($index, opt)) {
  <mat-option [value]="readValue(opt)">
    {{ readLabel(opt) }}
  </mat-option>
}

    @if (filter() && filteredOptions().length === 0) {
      <div class="p-3 text-sm text-gray-500 italic">
        No se encontraron resultados
      </div>
    }
  </mat-select>

  @if (control().invalid && control().touched) {
  <mat-error>{{ 'shared.validationMessages.selectRequired' | translate }}</mat-error>
}
</mat-form-field>